import { TeamMember, SocialPlatform } from "@/lib/types";

export const teamMembers: TeamMember[] = [
    {
        name: "RiceHat",
        title: "StarCraft nerd / CEO",
        profilePicture: "/assets/profilePictures/ricehat.png",
        socials: [
            {
                social: SocialPlatform.twitter,
                link: "https://x.com/ricehat80"
            },
            {
                social: SocialPlatform.email,
                link: "mailto:haoda@nextgg.live"
            }
        ],
        bio: "Secretly trying to revive the RTS genre using VTubers",
        gameOfChoice: "StarCraft"
    },
    {
        name: "Vapourwaifu",
        title: "Head Talent Manager",
        profilePicture: "/assets/profilePictures/vapourwaifu.png",
        socials: [
            {
                social: SocialPlatform.twitter,
                link: "https://x.com/vapourwaifu"
            },
            {
                social: SocialPlatform.email,
                link: "mailto:justin@nextgg.live"
            }
        ],
        bio: "Scheming courtier and weeaboo on retainer",
        gameOfChoice: "The Witcher 3: Wild Hunt"
    },
    {
        name: "ForTheThrills",
        title: "CFO",
        profilePicture: null,
        socials: [
            {
                social: SocialPlatform.email,
                link: "mailto:malcolm@nextgg.live"
            }
        ],
        bio: "Part-time UmaTuber, Full-time Umamusume T100 Club Leader",
        gameOfChoice: "Umamusume"
    },
    {
        name: "Frank",
        title: "Just Frank",
        profilePicture: "/assets/profilePictures/frank.png",
        socials: [
            {
                social: SocialPlatform.email,
                link: "mailto:frank@nextgg.live"
            }
        ],
        bio: "Average Bay Street bean counter, what's a VTuber?",
        gameOfChoice: "Touching grass"
    },
    {
        name: "Hadron",
        title: "Tech Wizard",
        profilePicture: "/assets/profilePictures/hadron.png",
        socials: [
            {
                social: SocialPlatform.email,
                link: "mailto:ryan@nextgg.live"
            }
        ],
        bio: "Washed up engineer.",
        gameOfChoice: "Factorio"
    }
]